<template>
  <div class="home-page">
    <!-- 导航栏 -->
    <WebsiteNavbar />

    <!-- 主视觉区/轮播图 -->
    <HeroBanner />

    <!-- 产品展示区 -->
    <ProductShowcase />

    <!-- 联系我们 CTA -->
    <ContactCTA />

    <!-- 页脚 -->
    <WebsiteFooter />
  </div>
</template>

<script setup lang="ts">
import WebsiteNavbar from './components/WebsiteNavbar.vue'
import HeroBanner from './components/HeroBanner.vue'
import ProductShowcase from './components/ProductShowcase.vue'
import ContactCTA from './components/ContactCTA.vue'
import WebsiteFooter from './components/WebsiteFooter.vue'
</script>

<style scoped>
.home-page {
  font-family: 'Helvetica Neue', Helvetica, Arial, 'Microsoft YaHei', sans-serif;
  color: #333;
  overflow-x: hidden;
}
</style>
